import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { ModalDialogResult } from '../../../models/modal-dialog-result';
import { CommonModule } from '@angular/common';
import { FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-reject',
  standalone: true,
  imports: [
    CommonModule,
    FormlyModule,
    ReactiveFormsModule,
  ],
  templateUrl: './reject-reason.component.html',
  styleUrl: './reject-reason.component.scss'
})
export class RejectReasonComponent {
  @Input() title: string = 'Reject?';
  @Input() message: string = 'Please confirm that you want to reject the application and send it back to the visitor?';

  public onClose: Subject<ModalDialogResult<string>> = new Subject();

  model: any = {};
  form = new FormGroup({});
  fields: FormlyFieldConfig[] = [
    {
      key: 'reason',
      type: 'textarea',
      props: {
        label: 'Reason',
        placeholder: 'Please explain why you want to reject, so the visitor knows what to do',
        required: true,
        rows: 5
      },
    }
  ];

  constructor(public activeModal: NgbActiveModal) {
  }

  ok() {
    this.onClose.next({ result: true, entity: this.model.reason });
    this.activeModal.dismiss();
  }

  cancel() {
    this.onClose.next({ result: false, entity: null });
    this.activeModal.dismiss();
  }
}
